<div class="pt-4">
  <div class="mb-4 flex items-center justify-between gap-4">
    <div>
      <h3 class="m-0 text-lg font-semibold">DFM Checks</h3>
      <p class="m-0 text-sm text-muted-color">
        DFM results for the selected CAD object.
      </p>
    </div>
    <p-button
      label="Refresh"
      icon="pi pi-refresh"
      severity="secondary"
      [loading]="revisionItemService.dfmRerunning()"
      (onClick)="refresh()"
    />
  </div>
  @if (checks.length) {
    @for (check of checks; track check.id) {
      <app-dfm-check-item
        [dfmCheck]="check"
        [selectedDFMCheck]="selectedDFMCheck"
        [cadObjectName]="item.name"
        (toggleDFMCheck)="toggle($event)"
      />
    }
  } @else {
    <div class="py-8 text-center text-muted-color">
      No DFM checks are available for this CAD object.
    </div>
  }
</div>
